frontApp.cart = {
  name: 'cart',
  description: 'products add to the cart',
  init() {
    this.events();
  },
  events() {
    const self = this;
    $(document)
      .on('click', '.js-ajax-buy', function (event) {
        if (dataLayer) {
          // eslint-disable-next-line
          dataLayer.push({'event': 'v_korzinu'});
        }
        const $curButton = $(this);
        const id = $curButton.data('id');
        if (!$curButton.hasClass('is-active')) {
          event.preventDefault();
          frontApp.loading.fullPage.show();
          $.post(
            '/local/ajax/add2basket.php',
            {
              id,
            },
            (data) => {
              self.refreshCart();
              self.setProductCartBtn(id, 1);
              if (data.success && typeof bAnalytics !== 'undefined') {
                bAnalytics.add2cart(id);
              }
              frontApp.loading.fullPage.hide();
            },
            'json',
          );
        }
      })
      .on('click', '.js-buy-one-click', function (event) {
        event.preventDefault();
        frontApp.loading.fullPage.show();
        $.post(
          '/local/ajax/buy1click.php',
          {
            PRODUCT_ID: $(this).data('id'),
          },
          (html) => {
            $('body').append(html);
            frontApp.loading.fullPage.hide();
            // Lock body scroll
            const scrollContainer = document.querySelector('.b_popup__overlay');
            if (scrollContainer) {
              document.body.style.marginRight = `${(window.innerWidth - document.documentElement.clientWidth)}px`;
              bodyScrollLock.disableBodyScroll(scrollContainer);
            }
          },
          'html',
        );
        return false;
      });
  },
  refreshCart() {
    $.post(
      '/local/ajax/reload_cart.php',
      {
      },
      (data) => {
        $('.ajax_head_basket').html($(data).removeClass('header__user-item'));
      },
      'html',
    );
  },
  setProductCartBtn(id) {
    const $curButton = $(`.buy_button__${id}`);
    $curButton.addClass('is-active');
    $curButton.attr('href', '/personal/cart/');
    const $content = $curButton.children('span');
    if ($content.length) {
      $content.eq(0).html('В корзину');
      $content.eq(1).html('Перейти в корзину');
    } else {
      $curButton.html('В корзине');
    }
  },
};
